import { includes, isEmpty, omit } from 'lodash'
import queryString from 'query-string'

import excel from '@/assets/images/file-icon/excel.png'
import image from '@/assets/images/file-icon/image.svg'
import pdf from '@/assets/images/file-icon/pdf.png'
import word from '@/assets/images/file-icon/word.png'
import zip from '@/assets/images/file-icon/zip.png'
import { KIEN_NGHI_KIEM_TOAN } from '@/constants/variables'
import { PAGINATION } from './variables'
import { Departments } from '@/types/departments.type'
import { TreeNode } from '@greenglobal/greencore.fe.common/dist/components/Tree'
import { Breadcrumbs } from '@/types/common.type'
import { Units } from '@/types/unit.type'
import { getDownLoadFile } from '@/services/common'
import FileSaver from 'file-saver'
import { notification } from '@greenglobal/greencore.fe.common'
import { MESSAGE } from '@/constants/message'

type PaginationType = {
  total: number
  query: { page: number; limit: number }
  callback: ({ page, limit }: { page?: number; limit?: number }) => void
}

type TreeChildren = {
  children?: TreeChildren[] | null
  [key: string]: any
}

export function flattenData(arr: any[]) {
  return arr.reduce((result: any, item: any) => {
    result = [...result, omit(item, 'children')]

    if (item.children) {
      result = [...result, ...flattenData(item.children)]
    }

    return result
  }, [])
}

// Render icon file theo fileName
export const getImageExtension = (fileName: string) => {
  const lastDotPosition = fileName?.lastIndexOf('.')
  const fileType = fileName?.slice(lastDotPosition, fileName?.length)?.toLowerCase()
  switch (fileType) {
    case '.docx':
    case '.doc':
      return word
    case '.xls':
    case '.xlsx':
      return excel
    case '.pdf':
      return pdf
    case '.zip':
      return zip
    case '.rar':
      return zip
    default:
      return image
  }
}

const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
export const convertDatetimeInstantFormat = (data: string) => {
  return dayjs(data).startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
}

// sort danh sách kết luận
export const handleSort = (setFilter: any) => (pagination: number, filters: any, sorter: any) => {
  const arrSort = [] as any
  const { order, columnKey } = sorter
  if (columnKey === 'ten') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'ngayBanHanhQuyetDinh') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'ngayHoanThanhKetLuan') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'trangThaiKetLuan') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'loaiKetLuanThanhTra') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'ngayBanHanh') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  setFilter((prev: any) => ({
    ...prev,
    // sort: arrSort
    sort: arrSort.length ? arrSort.join(',') : 'ngayBanHanh,desc'
  }))
}

// sort danh sách kết nghị thanh tra
export const handleSortKienNghiThanhTra = (setFilter: any) => (pagination: number, filters: any, sorter: any) => {
  const arrSort = [] as any
  const { order, columnKey } = sorter
  if (columnKey === 'ngayBanHanh') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'thoiHanThucHien') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'tenDonViGiao') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  if (columnKey === 'trangThaiNhanThucHienKienNghi') {
    if (order === 'ascend') {
      arrSort.push(`${columnKey},asc`)
    }
    if (order === 'descend') {
      arrSort.push(`${columnKey},desc`)
    }
  }
  setFilter((prev: any) => ({
    ...prev,
    sort: arrSort
  }))
}

// covert number
// export const convertNumberToFormattedString = (number: any) => {
//   if (!number) return 0

//   const numericValue = Number(number)
//   if (isNaN(numericValue)) return number

//   return numericValue.toLocaleString('vi-VN')
// }
export const convertNumberToFormattedString = (value: any) => {
  if (!value) return '0'
  const isPercent = typeof value === 'string' && value.includes('%')
  const rawValue = isPercent ? value.replace('%', '') : value
  const numericValue = Number(rawValue)
  if (isNaN(numericValue)) return value
  const formattedNumber = numericValue.toLocaleString('vi-VN')
  return isPercent ? `${formattedNumber}%` : formattedNumber
}
// covert số thập phân
export const convertToDecimal = (value: any) => parseFloat(value.replace(',', '.'))

// title kiến nghị
export const titleKienNghi = (data: string) => {
  switch (data) {
    case 'THU_HOI_VE_NSNN':
      return 'Kiến nghị thu hồi về ngân sách nhà nước'
    case 'XU_LY_VE_KINH_TE':
      return 'Kiến nghị xử lý về kinh tế khác'
    case 'XU_LY_VE_HANH_CHINH':
      return 'Kiến nghị hành chính khác'
    case 'XU_LY_CHUYEN_CQDT':
      return 'Kiến nghị xử lý chuyển cơ quan điều tra'
    case 'HOAN_THIEN_CO_CHE_CHINH_SACH':
      return 'Kiến nghị hoàn thiện cơ chế chính sách'
    case 'KIEM_DIEM_TRACH_NHIEM':
      return 'Kiến nghị kiểm điểm trách nhiệm'
    case 'XU_LY_KHAC':
      return 'Kiến nghị xử lý khác'
  }
}

// title kiến nghị
export const titleKienNghiKTNN = (data: string) => {
  switch (data) {
    case 'KTNN_XU_LY_TAI_CHINH':
      return 'Kiến nghị xử lý về tài chính'
    case 'KTNN_XU_LY_CO_CHE_CHINH_SACH':
      return 'Kiến nghị xử lý về cơ chế chính sách'
    case 'KTNN_XU_LY_KIEM_DIEM_XU_LY_TRACH_NHIEM':
      return 'Kiến nghị xử lý về kiểm điểm, xử lý trách nhiệm tập thể, cá nhân có liên quan'
    case 'KTNN_CHAN_CHINH_RUT_KINH_NGHIEM':
      return 'Kiến nghị chấn chỉnh, rút kinh nghiệm'
    case 'KTNN_XU_LY_KHAC':
      return 'Kiến nghị khác'
  }
}

// title kiến nghị kiểm toán
export const titleKienNghiKiemToan = (data: string) => {
  switch (data) {
    case KIEN_NGHI_KIEM_TOAN.KTNN_XU_LY_TAI_CHINH:
      return 'Kiến nghị xử lý tài chính'
    case KIEN_NGHI_KIEM_TOAN.KTNN_XU_LY_CO_CHE_CHINH_SACH:
      return 'Kiến nghị cơ chế chính sách'
    case KIEN_NGHI_KIEM_TOAN.KTNN_XU_LY_KIEM_DIEM_XU_LY_TRACH_NHIEM:
      return 'Kiến nghị về kiểm điểm, xử lý trách nhiệm tập thể, cá nhân có liên quan'
    case KIEN_NGHI_KIEM_TOAN.KTNN_CHAN_CHINH_RUT_KINH_NGHIEM:
      return 'Kiến nghị chấn chỉnh, rút kinh nghiệm'
    case KIEN_NGHI_KIEM_TOAN.KTNN_XU_LY_KHAC:
      return 'Kiến nghị xử lý khác'
  }
}

// title kết luận
export const titleKetLuan = (data: string) => {
  switch (data) {
    case 'THANH_TRA':
      return 'Kết luận thanh tra'
    case 'KIEN_NGHI_KTNN':
      return 'Kết luận kiến nghị của Kiểm toán nhà nước'
  }
}

// convertYearToISO
export const convertYearToISO = (year: number) => {
  return dayjs(`${year}-01-01T00:00:00.000Z`)
    .set('hour', 23)
    .set('minute', 59)
    .set('second', 59)
    .set('millisecond', 999)
}

// Số thứ tự danh sách
export const serialOrder = (page = PAGINATION.PAGE, index: number, size = PAGINATION.PAGE_SIZE) => {
  const num = (page - 1) * size + index + 1
  return num
}

export const removeUndefinedValue = (data: any) => {
  const result = { ...data }
  Object.keys(result).forEach((key) => {
    if (result[key] === undefined) {
      delete result[key]
    }
  })
  return result
}

export const mapDepartmentsToTreeNodes = (departments?: Departments.Type[]): TreeNode[] | undefined => {
  if (!departments) return []

  return departments.map((department: Departments.Type) => ({
    label: department.name,
    value: department.id,
    children: mapDepartmentsToTreeNodes(department.children)
  }))
}

export const mapUnitsToTreeNodes = (units?: Units.Type[], currentId?: number): TreeNode[] | undefined => {
  if (!units) return []

  return units.map((unit: Units.Type) => ({
    label: unit.name,
    value: unit.id,
    disabled: unit.id === currentId,
    children: unit.id === currentId ? [] : [...(mapUnitsToTreeNodes(unit.children, currentId) || [])]
  }))
}

export const mapDepartmentsToTreeSelect = (departments?: Departments.Type[]): TreeNode[] | undefined => {
  if (!departments) return []

  return departments.map((department: Departments.Type) => ({
    title: department.name,
    key: department.id,
    type: 'department',
    value: department.id,
    children: mapDepartmentsToTreeSelect(department.children)
  }))
}

export const mapUnitsToTreeSelect = (units?: Units.Type[]): TreeNode[] | undefined => {
  if (!units) return []

  return units.map((unit: Units.Type) => ({
    title: unit.name,
    key: unit.id,
    type: 'unit',
    value: unit.id,
    children: [...(mapUnitsToTreeSelect(unit.children) || []), ...(mapDepartmentsToTreeSelect(unit.departments) || [])]
  }))
}

export const recursiveBreadcrumbs = (data: Breadcrumbs.Type) => {
  if (isEmpty(data)) {
    return []
  }

  const result = [data]

  if (!isEmpty(data.child)) {
    result.push(...recursiveBreadcrumbs(data.child!))
  }

  return result
}

export const getBreadcrumbs = (
  dataBreadcrumbs: Breadcrumbs.Type,
  pathName: string,
  name: string,
  parentUrl?: string
) => {
  const flatted = recursiveBreadcrumbs(dataBreadcrumbs)

  const breadcrumbs = flatted?.map((breadcrumb: Breadcrumbs.Type) => {
    return {
      name: breadcrumb?.name,
      url: `${pathName}/${breadcrumb?.id}`
    }
  })

  const convertBreadCrumb =
    [{ name, url: parentUrl, child: null }, ...breadcrumbs].map((item: Breadcrumbs.Type, index: number) => {
      if (breadcrumbs?.length === index) {
        return {
          name: item?.name,
          url: undefined
        }
      }
      return item
    }) || []

  return convertBreadCrumb
}

export const pagination = ({ total, query, callback }: PaginationType) => ({
  total: total,
  pageSize: query?.limit || PAGINATION.PAGE_SIZE,
  defaultCurrent: Number(query?.page || PAGINATION.PAGE),
  current: Number(query?.page || PAGINATION.PAGE),
  showSizeChanger: PAGINATION.SHOW_SIZE_CHANGER,
  pageSizeOptions: PAGINATION.PAGE_SIZE_OPTIONS,
  locale: { items_per_page: PAGINATION.PER_PAGE_TEXT },
  onChange: (page: number, size: number) => {
    callback({ page, limit: size })
  },
  onShowSizeChange: (current: number, size: number) => {
    callback({ page: current, limit: size })
  },
  showTotal: (total: number, [start, end]: [number, number]) => `Hiển thị ${start}-${end} trong ${total}`
})

export const removeEmptyChildren = <T extends TreeChildren>(data: T[]): T[] => {
  return data?.map((item) => {
    const updatedItem = { ...item }

    if (updatedItem.children && updatedItem.children.length === 0) {
      updatedItem.children = null
    } else if (updatedItem.children) {
      updatedItem.children = removeEmptyChildren(updatedItem.children)
    }

    return updatedItem
  })
}

export const trimValue = (value: string) => value.trim()

export const onSearchParams = <T extends Record<string, any>>(params: T, pathname: string) => {
  const string = queryString.stringify(params)

  if (typeof window !== 'undefined') {
    window.history.pushState({}, '', `${location.pathname}?${string}`)
  }
}

// Download file màn hình chi tiết
export const downloadFileDetail = async (record: any) => {
  const mimeTypes = {
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pdf: 'application/pdf',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    jpg: 'image/jpeg',
    png: 'image/png'
  } as any
  try {
    const response = await getDownLoadFile(record?.file_dinh_kem_id)
    if (response) {
      const blob = new Blob([response.data], {
        type: mimeTypes[record?.document_store?.extension]
      })
      FileSaver.saveAs(blob, record?.document_store?.original_name || '')
    } else {
      notification({
        message: MESSAGE.ERROR_SYSTEM,
        type: 'error'
      })
    }
  } catch (_) {
    notification({
      message: MESSAGE.ERROR_SYSTEM,
      type: 'error'
    })
  }
}

export const checkPermission = (permissions: string[], userPermissions: string[]) => {
  if (isEmpty(permissions)) {
    return true
  }
  if (!isEmpty(permissions) && isEmpty(userPermissions)) {
    return false
  }
  return permissions.every((permission) => userPermissions?.includes(permission))
}

export const getColorThoiHan = (thoiHan: string) => {
  if (!thoiHan) return undefined // Xử lý chuỗi rỗng hoặc không hợp lệ

  if (thoiHan.includes('Trễ hạn')) {
    return '#FD4141'
  }

  if (thoiHan.includes('Hoàn thành trễ hạn')) {
    const match = thoiHan.match(/(\d+)\s+ngày/) // Tìm số trước từ "ngày"
    const daysLate = match ? parseInt(match[1], 10) : NaN
    if (!isNaN(daysLate)) {
      return '#FD4141'
    }
  }

  if (thoiHan.includes('Còn')) {
    const match = thoiHan.match(/(\d+)\s+ngày/) // Tìm số trước từ "ngày"
    const days = match ? parseInt(match[1], 10) : NaN
    if (!isNaN(days) && days <= 10) {
      return '#F59E0B'
    }
  }

  return undefined
}

const FILE_API = process.env.REACT_APP_API_FILE
export const openFileInNewTab = (path: string) => {
  const url = `${FILE_API}/${path}`
  window.open(url, '_blank', 'noopener,noreferrer')
}

export const convertNewlineToBreak = (text: string): string => {
  if (!text) return ''
  return text?.replace(/\n/g, '<br>')
}

const LOAI_XU_LY_LABEL: Record<string, string> = {
  DANG: 'Đảng',
  CHINH_QUYEN: 'Chính quyền',
  KHAC: 'Khác'
}

export const convertLoaiXuLy = (value?: string | null): string => {
  if (!value) return ''
  return LOAI_XU_LY_LABEL[value] ?? value
}

export const filterDataTableVBDH = (
  data: any,
  fields = ['ten', 'so_van_ban', 'ngay_ra_van_ban', 'file_dinh_kem_id']
) => {
  return data?.filter((item: any) =>
    fields?.some((field) => {
      const value = item[field]
      return value !== undefined && value !== null && String(value).trim() !== ''
    })
  )
}
